export default __webpack_public_path__ + "static/media/calendar2.fb27b2db.jpg";